<template>
    <td-dialog :title="title" :before-close="userDetailDialogClose" :visible.sync="dialogUserDetailVisible" width="72%" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formUserInfo" ref="formUserInfo" :rules="rules">
            <el-row>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.BASE_INFO') }}</span>
                    </div>
                    <el-col :span="8">
                        <el-form-item :label="$t('common.USERNAME')" :label-width="formLabelWidth">
                            {{ this.formUserInfo.sName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('common.ROLE_INFO')" :label-width="formLabelWidth">
                            {{ this.formUserInfo.roleName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('role.DOOR_ROLE')" :label-width="formLabelWidth">
                            {{ this.formUserInfo.doorRole }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('common.VALIDITY_TO')" :label-width="formLabelWidth">
                            {{ this.formUserInfo.dtLimit }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('common.LOCK_STATE')" :label-width="formLabelWidth">
                            {{ this.formUserInfo.iLockType }}
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>
            <el-row v-if="this.formUserInfo.ipList.length !== 0">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.IP_WHITE_LIST') }}</span>
                    </div>
                    <el-col>
                        <el-form-item>
                            {{ this.formUserInfo.ipList }}
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>
            <el-row v-if="this.formUserInfo.macList.length !== 0">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.MAC_WHITE_LIST') }}</span>
                    </div>
                    <el-col>
                        <el-form-item>
                            {{ this.formUserInfo.macList }}
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>
            <el-row v-if="this.checkedOrgList.length !== 0">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.DEPTMENT') }}</span>
                    </div>
                    <el-col>
                        <el-form-item>
                            {{ this.checkedOrgList }}
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>
            <el-row v-if="this.userPermissions.length !== 0">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.AUTH_INFO') }}</span>
                    </div>

                    <el-col v-for="authStr in this.userPermissions" :key="authStr" :span="8">
                        <el-form-item style="margin-bottom:2px;" :label="authStr.split('：')[0] + '：'" :label-width="formLabelWidth">
                            {{ authStr.split('：')[1] }}
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>

            <el-row v-for="extend in userExtends" :key="extend.sModuleId">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ extend.sModuleName }}</span>
                    </div>
                    <div v-for="item in extend.extendList" :key="item.sId">
                        <el-col :span="item.sExtendType === 'checkboxgroup' ? 24 : 8">
                            <el-form-item :key="item.sId" :label-width="item.sExtendType === 'checkboxgroup' ? '15%' : formLabelWidth" :label="item.sName">
                                <div v-if="item.sExtendType === 'input'">
                                    <td-input v-model="item.optionValue" :type="item.sParam" :disabled="disableType" placeholder=""></td-input>
                                </div>
                                <div v-if="item.sExtendType === 'combobox'" style="height:36px;">
                                    <!-- <td-select :options="item.sParam.split(',')" :keys="" prop="sName"></td-select> -->
                                    <el-select v-model="item.optionValue" placeholder="" :disabled="disableType">
                                        <el-option v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"> </el-option>
                                    </el-select>
                                </div>
                                <div v-if="item.sExtendType === 'date'">
                                    <el-date-picker type="date" :placeholder="$t('common.SELECT_DATE')" v-model="item.optionValue" :disabled="disableType"></el-date-picker>
                                </div>
                                <div v-if="item.sExtendType === 'radio'">
                                    <el-radio-group v-model="item.optionValue" :disabled="disableType">
                                        <el-radio v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"></el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="item.sExtendType === 'checkbox'">
                                    <el-checkbox v-model="item.optionValue" :label="item.sParam" :disabled="disableType">{{ item.sParam }}</el-checkbox>
                                </div>
                                <div v-if="item.sExtendType === 'checkboxgroup'">
                                    <el-checkbox-group v-model="item.optionValue" :disabled="disableType">
                                        <el-checkbox v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" style="width:100px;margin:5px 0 0 0;"></el-checkbox>
                                    </el-checkbox-group>
                                    <!-- <td-checkbox-group v-model ="item.optionValue" :allList="item.sParam.split(',')" ></td-checkbox-group> -->
                                </div>
                            </el-form-item>
                        </el-col>
                    </div>
                </el-card>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="button" @click="userDetailDialogClose()">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogUserDetailVisible', 'editItem', 'sysFlg'],
    created() {
        this.formUserInfo.sId = this.editItem.userId;
        this.formUserInfo.roleList = this.editItem.roleId;
        // 获取当前用户信息
        let param = {
            userId: this.formUserInfo.sId,
            sSysFlg: this.sysFlg,
            currentPage: 1,
            pageSize: 10
        };
        resourceApi.getUserIpList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserIpList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrIp = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrIp.push(element.sIp);
            }
            this.formUserInfo.ipList = arrIp.join(',');
        });
        resourceApi.getUserMacList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserMacList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrMac = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrMac.push(element.sMac);
            }
            this.formUserInfo.macList = arrMac.join(',');
        });
        resourceApi.listUserInfos(param, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getAllUsers', response.data.statusMessage);
                return;
            }
            let userInfo = response.data.content;
            for (let index = 0; index < userInfo.length; index++) {
                const element = userInfo[index];
                this.formUserInfo.sName = element.userName;
                // this.formUserInfo.ipList = element.sIpControl.replace(/#/g, ',')
                this.formUserInfo.dtLimit = this.formatDate(new Date(element.dtLimit * 1), 'yyyy-MM-dd');
                this.formUserInfo.roleName = element.roleName;
                if (element.iLockType === 1) {
                    this.formUserInfo.iLockType = this.$t('common.LOCK');
                } else {
                    this.formUserInfo.iLockType = this.$t('common.NORMAL');
                }
                break;
            }
        });
        // 获取所属组织
        let paramOrgInfo = {
            sId: this.formUserInfo.sId,
            sysID: this.sysFlg,
            orgFlg: 1
        };

        resourceApi.getUserRoleInfo(JSON.stringify(paramOrgInfo), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let orgNames = [];
            for (let index = 0; index < array.length; index++) {
                orgNames.push(array[index].sName);
            }
            this.checkedOrgList = orgNames.join(',');
        });
        //门禁权限组
        let doorRoleQueryParam = {
            sId: this.formUserInfo.sId,
            sysFlg: this.sysFlg,
            orgFlg: 2
        };
        resourceApi.getUserRole(JSON.stringify(doorRoleQueryParam), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRole', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            if (array.length > 0) {
                this.formUserInfo.doorRole = array[0].sName;
            }
        });
        // 获取权限列表
        let paramAuthInfo = {
            sId: this.formUserInfo.sId,
            roleList: this.formUserInfo.roleList,
            sysID: this.sysFlg
        };

        resourceApi.getUserAuthInfo(JSON.stringify(paramAuthInfo), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserAuthInfo', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let permissions = [];
            let auths = [];
            for (let index = 0; index < array.length; index++) {
                permissions.push(array[index].resTypeName);
                auths.push(array[index].authName);
            }
            let arrAuthStr = [];
            let temp = '';
            for (let index = 0; index < permissions.length; index++) {
                if (temp.indexOf(permissions[index]) === -1) {
                    if (temp !== '') {
                        arrAuthStr.push(temp);
                    }
                    temp = permissions[index] + '：' + auths[index];
                } else {
                    temp += '，' + auths[index];
                }
            }
            if (temp !== '') arrAuthStr.push(temp);
            this.userPermissions = arrAuthStr;
        });

        // 获取用户扩展信息
        resourceApi.getUserExtends({ sysFlg: this.sysFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserExtends', response.data.statusMessage);
                return;
            }
            let data = response.data.content;
            this.userExtends = data;
            console.log(this.userExtends);
            // 为编辑状态则进行初始化数据
            let content = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg
            };

            resourceApi.getUserExtendsValues(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserExtendsValues', response.data.statusMessage);
                    return;
                }

                let values = response.data.content;
                if (values.length == 0) {
                    return;
                }
                let i = 0;
                this.userExtends.forEach(v => {
                    v.extendList.forEach(val => {
                        if (val.sExtendType === 'checkboxgroup') {
                            let arr = values[i].sValue.split('|');
                            val.optionValue = arr;
                        } else if (val.sExtendType === 'checkbox') {
                            let arr = values[i].sValue === 'true';

                            val.optionValue = arr;
                        } else {
                            val.optionValue = values[i].sValue;
                        }
                        i++;
                    });
                });
            });
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {},
    // 定义数据
    data() {
        return {
            formUserInfo: {
                sId: '',
                sName: '',
                dateTo: '',
                ipList: '',
                macList: '',
                dtLimit: '',
                roleList: '',
                roleName: '',
                doorRole: '',
                iLockType: ''
            },
            disableType: true,
            userExtends: [],
            checkedOrgList: '',
            userPermissions: [],
            formLabelWidth: '30%',
            dialogResetPasswordVisible: false
        };
    },
    // 方法的实现
    methods: {
        userDetailDialogClose() {
            this.$emit('userDetailDialogClose');
        },
        formatDate(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
